(function () {
  'use strict';

  /* ─── Locate the closest funnel component wrapper ─── */
  function getFunnel(el) {
    return el.closest('product-funnel-component');
  }

  /* ─── Store field values on the funnel dataset ─── */
  function storeValue(funnel, key, value) {
    if (!funnel) return;
    funnel.dataset['fp' + key] = value;
  }

  /* ─── Validate: all required fp fields filled ─── */
  function isComplete(block) {
    var vorname = block.querySelector('.fp-vorname');
    if (!vorname || !vorname.value.trim()) return false;

    var gescFields = block.querySelectorAll('[data-fp-field="Geschlecht"]');
    var gescChecked = Array.prototype.some.call(gescFields, function (r) { return r.checked; });
    if (!gescChecked) return false;

    var haarFields = block.querySelectorAll('[data-fp-field="Haarfarbe"]');
    var haarChecked = Array.prototype.some.call(haarFields, function (r) { return r.checked; });
    if (!haarChecked) return false;

    var augenFields = block.querySelectorAll('[data-fp-field="Augenfarbe"]');
    var augenChecked = Array.prototype.some.call(augenFields, function (r) { return r.checked; });
    if (!augenChecked) return false;

    return true;
  }

  /* ─── Also check photo is uploaded ─── */
  function isPhotoUploaded(funnel) {
    if (!funnel) return false;
    var photoInput = funnel.querySelector('.funnel-photo-upload__input');
    return photoInput && photoInput.files && photoInput.files.length > 0;
  }

  /* ─── Update the Weiter button enabled state ─── */
  function updateNextButton(block) {
    var funnel = getFunnel(block);
    var nextBtn = funnel && funnel.querySelector('[ref="uploadNextButton"]');
    if (!nextBtn) return;

    /* Don't re-enable while the loading state is active */
    if (nextBtn.dataset.loading === 'true') return;

    var complete = isComplete(block);
    nextBtn.disabled = !complete;
  }

  /* ─── Update the photo Weiter button enabled state ─── */
  function updatePhotoButton(funnel) {
    var btn = funnel && funnel.querySelector('[ref="uploadNextButton2"]');
    if (!btn) return;
    btn.disabled = !isPhotoUploaded(funnel);
  }

  /* ─── Step navigation ─── */
  function initStepNav() {
    var weiterBtn   = document.getElementById('fs-weiter-btn');   // 1 → 2
    var weiter2Btn  = document.getElementById('fs-weiter2-btn');  // 2 → 3
    var zurueckBtn  = document.getElementById('fs-zurueck-btn');  // 2 → 1
    var zurueck2Btn = document.getElementById('fs-zurueck2-btn'); // 3 → 2
    var step1 = document.getElementById('fs-step-1');
    var step2 = document.getElementById('fs-step-2');
    var step3 = document.getElementById('fs-step-3');

    if (weiterBtn) {
      weiterBtn.addEventListener('click', function () {
        if (step1) step1.hidden = true;
        if (step2) step2.hidden = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    if (weiter2Btn) {
      weiter2Btn.addEventListener('click', function () {
        if (step2) step2.hidden = true;
        if (step3) step3.hidden = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    if (zurueckBtn) {
      zurueckBtn.addEventListener('click', function () {
        if (step2) step2.hidden = true;
        if (step1) step1.hidden = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    if (zurueck2Btn) {
      zurueck2Btn.addEventListener('click', function () {
        if (step3) step3.hidden = true;
        if (step2) step2.hidden = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  /* ─── Variant update: reads cover + inner box active state ─── */
  function fsUpdateVariant() {
    var coverInput = document.querySelector('input[name="fs-cover"]:checked');
    var cover = coverInput ? coverInput.value : null;

    var boxA = document.getElementById('fs-widmung-box-a');
    var boxB = document.getElementById('fs-widmung-box-b');
    var widmung = (boxA && boxA.classList.contains('is-active')) ||
                  (boxB && boxB.classList.contains('is-active'));

    if (!cover || !window.fsFunnelVariants) return;

    var widmungOption = widmung ? 'Widmung' : 'ohne Widmung';

    var variant = window.fsFunnelVariants.find(function (v) {
      return v.options.indexOf(cover) !== -1 && v.options.indexOf(widmungOption) !== -1;
    });

    if (!variant) return;

    var variantInput = document.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = variant.id;
  }

  /* ─── Enable submit button only after a cover type is chosen ─── */
  function fsUpdateSubmitBtn() {
    var btn = document.querySelector('[ref="submitButton"]');
    if (!btn) return;
    if (btn.dataset.loading === 'true') return;
    var coverSelected = document.querySelector('input[name="fs-cover"]:checked');
    btn.disabled = !coverSelected;
  }

  /* ─── Cover card radio change ─── */
  function initCoverCards() {
    document.querySelectorAll('input[name="fs-cover"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        document.querySelectorAll('.fs-cover-card').forEach(function (card) {
          var r = card.querySelector('input[type="radio"]');
          card.classList.toggle('is-selected', !!(r && r.checked));
        });
        fsUpdateVariant();
        fsUpdateSubmitBtn();
      });
    });
  }

  /* ─── Update widmung option text when child name changes ─── */
  function updateWidmungOptionName(name) {
    var displayName = (name && name.trim()) ? name.trim() : '[Name]';
    document.querySelectorAll('.fs-widmung-option-text').forEach(function (el) {
      var tmpl = el.dataset.template || '';
      el.textContent = tmpl.replace(/\[Name\]/g, displayName);
    });
    var boxA = document.getElementById('fs-widmung-box-a');
    var boxB = document.getElementById('fs-widmung-box-b');
    if (boxA && boxA.classList.contains('is-active') && !(boxB && boxB.classList.contains('is-active'))) {
      var checked = document.querySelector('input[name="fs-widmung-option"]:checked');
      var ta = document.getElementById('fs-widmungstext');
      if (checked && ta) {
        var lbl = checked.closest('.fs-widmung-option');
        var span = lbl && lbl.querySelector('.fs-widmung-option-text');
        if (span) ta.value = span.textContent.trim();
      }
    }
  }

  /* ─── Widmung: inner two-box system (no outer toggle) ─── */
  function initWidmungToggle() {
    var boxA = document.getElementById('fs-widmung-box-a');
    var boxAHeader = document.getElementById('fs-widmung-box-a-header');
    var boxAContent = document.getElementById('fs-widmung-box-a-content');
    var boxB = document.getElementById('fs-widmung-box-b');
    var boxBBtn = document.getElementById('fs-widmung-box-b-btn');
    var boxBContent = document.getElementById('fs-widmung-box-b-content');
    var textarea = document.getElementById('fs-widmungstext');

    if (!boxA || !boxB) return;

    function getSelectedOptionText() {
      var checked = document.querySelector('input[name="fs-widmung-option"]:checked');
      if (!checked) return '';
      var lbl = checked.closest('.fs-widmung-option');
      var span = lbl && lbl.querySelector('.fs-widmung-option-text');
      return span ? span.textContent.trim() : '';
    }

    function updateWidmungText() {
      if (!textarea) return;
      if (boxB.classList.contains('is-active')) {
        textarea.disabled = false;
      } else if (boxA.classList.contains('is-active')) {
        textarea.disabled = false;
        textarea.value = getSelectedOptionText();
      } else {
        textarea.disabled = true;
        textarea.value = '';
      }
      fsUpdateVariant();
    }

    function activateBoxA() {
      boxA.classList.add('is-active');
      if (boxAContent) boxAContent.hidden = false;
      boxB.classList.remove('is-active');
      if (boxBContent) boxBContent.hidden = true;
      var anyChecked = document.querySelector('input[name="fs-widmung-option"]:checked');
      if (!anyChecked) {
        var opt1 = document.getElementById('fs-widmung-opt-1');
        if (opt1) opt1.checked = true;
      }
      var nameInput = document.querySelector('.fp-vorname');
      if (nameInput) updateWidmungOptionName(nameInput.value);
      updateWidmungText();
    }

    function activateBoxB() {
      boxB.classList.add('is-active');
      if (boxBContent) boxBContent.hidden = false;
      boxA.classList.remove('is-active');
      if (boxAContent) boxAContent.hidden = true;
      document.querySelectorAll('input[name="fs-widmung-option"]').forEach(function (r) { r.checked = false; });
      if (textarea) { textarea.disabled = false; textarea.value = ''; }
      updateWidmungText();
      setTimeout(function () { if (textarea) textarea.focus(); }, 50);
    }

    if (boxAHeader) {
      boxAHeader.addEventListener('click', function () { activateBoxA(); });
    }

    if (boxBBtn) {
      boxBBtn.addEventListener('click', function () { activateBoxB(); });
    }

    document.querySelectorAll('input[name="fs-widmung-option"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!boxA.classList.contains('is-active')) activateBoxA();
        else updateWidmungText();
      });
    });

    if (textarea) {
      textarea.addEventListener('input', function () {
        if (boxB.classList.contains('is-active')) updateWidmungText();
      });
    }
  }

  /* ─── Populate cover card prices from variant data ─── */
  function initCoverPrices() {
    if (!window.fsFunnelVariants) return;
    var moneyFormatEl = document.querySelector('.fs-funnel-money-format');
    var moneyFmt = moneyFormatEl ? moneyFormatEl.textContent.trim() : '{{amount}}';

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    ['Softcover', 'Hardcover'].forEach(function (cover) {
      var variant = window.fsFunnelVariants.find(function (v) {
        return v.options.indexOf(cover) !== -1 && v.options.indexOf('ohne Widmung') !== -1;
      });
      if (!variant) return;
      var el = document.querySelector('[data-cover-price="' + cover + '"]');
      if (el) el.textContent = formatMoney(variant.price);
    });
  }

  /* ─── Loading state on submit + Widmung text validation ─── */
  function initLoadingState() {
    var form = document.getElementById('FunnelProductForm');
    if (!form) return;

    var btn = form.querySelector('[ref="submitButton"]');
    if (!btn) return;

    var originalHTML = btn.innerHTML;

    form.addEventListener('submit', function (e) {
      var boxB = document.getElementById('fs-widmung-box-b');
      var textarea = document.getElementById('fs-widmungstext');
      var errEl = document.getElementById('fs-widmung-error');

      if (boxB && boxB.classList.contains('is-active') && textarea && !textarea.value.trim()) {
        e.preventDefault();
        if (errEl) { errEl.hidden = false; if (textarea) textarea.focus(); }
        return;
      }

      btn.dataset.loading = 'true';
      btn.disabled = true;
      btn.innerHTML = '<span class="funnel-dots" aria-hidden="true"><span></span><span></span><span></span></span>Einen Moment…';

      /* Safety net: re-enable if Shopify hasn't navigated away after 30 s */
      setTimeout(function () {
        btn.dataset.loading = 'false';
        btn.disabled = false;
        btn.innerHTML = originalHTML;
      }, 30000);
    });

    /* Re-enable immediately if browser validation blocks submission */
    form.addEventListener('invalid', function () {
      btn.dataset.loading = 'false';
      btn.disabled = false;
      btn.innerHTML = originalHTML;
    }, true);
  }

  /* ─── Field change handler ─── */
  function onFieldChange(e) {
    var field = e.target;
    if (!field.dataset.fpField) return;

    var block = field.closest('[data-fp-block]');
    if (!block) return;

    var funnel = getFunnel(block);
    if (!funnel) return;

    var key = field.dataset.fpField;
    var value = field.type === 'radio'
      ? (field.checked ? field.value : (funnel.dataset['fp' + key] || ''))
      : field.value;
    storeValue(funnel, key, value);

    updateNextButton(block);

    if (key === 'Vorname') {
      updateWidmungOptionName(value);
    }
  }

  /* ─── Photo change — re-evaluate combined state ─── */
  function onPhotoChange(e) {
    var input = e.target;
    var isPhotoInput = input.classList.contains('funnel-photo-upload__input');
    if (!isPhotoInput) return;

    var funnel = getFunnel(input);
    if (!funnel) return;

    if (input.files && input.files[0]) {
      storeValue(funnel, 'Foto', input.files[0].name);
    }

    setTimeout(function () { updatePhotoButton(funnel); }, 0);
  }

  /* ─── Boot ─── */
  function init() {
    document.addEventListener('change', onFieldChange, true);
    document.addEventListener('input',  onFieldChange, true);
    document.addEventListener('change', onPhotoChange, true);

    document.querySelectorAll('[data-fp-block]').forEach(function (block) {
      updateNextButton(block);
    });

    var funnel = document.querySelector('product-funnel-component');
    if (funnel) updatePhotoButton(funnel);

    initStepNav();
    initCoverCards();
    initCoverPrices();
    fsUpdateSubmitBtn();
    initWidmungToggle();
    initLoadingState();
    fsUpdateVariant();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
